import TheMobileHeaderSFC from "./TheMobileHeader.vue";
export type { ITheMobileHeaderProps } from "./props";
export const TheMobileHeader = TheMobileHeaderSFC;
